/**
 * @generated SignedSource<<86891424b96154bee7c56cabd00128a4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type walletPage_LinkMutation$variables = {
  action: string;
  bankAccountId?: string | null | undefined;
  qboAccountQboId: string;
};
export type walletPage_LinkMutation$data = {
  readonly sourcingAccountMerge: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly job: {
      readonly jobId: number;
      readonly status: string;
    } | null | undefined;
    readonly ok: boolean;
  } | null | undefined;
};
export type walletPage_LinkMutation = {
  response: walletPage_LinkMutation$data;
  variables: walletPage_LinkMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "action"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bankAccountId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "qboAccountQboId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "action",
    "variableName": "action"
  },
  {
    "kind": "Variable",
    "name": "bankAccountId",
    "variableName": "bankAccountId"
  },
  {
    "kind": "Variable",
    "name": "qboAccountQboId",
    "variableName": "qboAccountQboId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ok",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "AccountJob",
  "kind": "LinkedField",
  "name": "job",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jobId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "walletPage_LinkMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "SourcingAccountMergeMutationPayload",
        "kind": "LinkedField",
        "name": "sourcingAccountMerge",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "walletPage_LinkMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "SourcingAccountMergeMutationPayload",
        "kind": "LinkedField",
        "name": "sourcingAccountMerge",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "91ac3d30b9be7737b622f10862503e07",
    "id": null,
    "metadata": {},
    "name": "walletPage_LinkMutation",
    "operationKind": "mutation",
    "text": "mutation walletPage_LinkMutation(\n  $action: String!\n  $qboAccountQboId: String!\n  $bankAccountId: ID\n) {\n  sourcingAccountMerge(action: $action, qboAccountQboId: $qboAccountQboId, bankAccountId: $bankAccountId) {\n    ok\n    job {\n      jobId\n      status\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5ed6fff2e26b21737783c71ba888c650";

export default node;
